<div class="contact-area section-padding-80-50">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-6">
        <h2 class="contact-title mb-30">Get In <br />Touch</h2>
      </div>
      <div class="col-12 col-md-6 col-lg-3">
        <!-- Contact Info -->
        <div class="contact-info mb-30">
          <p><i class="fa fa-envelope"> Email</i></p>
          <a href="mailto:1703alpanapatel@gmail.com"
            >1703alpanapatel@gmail.com</a
          >
        </div>
        <!-- Contact Info -->
        <div class="contact-info mb-30">
          <p><i class="fa fa-phone"> Call </i></p>
          <a href="mailto:1703alpanapatel@gmail.com">(+91)XXXXXXXXXX</a>
        </div>
        <!-- Contact Info -->
        <div class="contact-info mb-30">
          <p><i class="fa fa-map-marker"> Visiting Address </i></p>
          <a href="#">HSR Layout, B'lore, India</a>
        </div>
      </div>
    </div>
  </div>
</div>
